import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import '98.css/dist/98.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
